import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedRankingClassifService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    /**
     * getRanking() - Buscar classificaçaão do ranking selecionado
     * @param rankingId : Identificador do ranking
     */
    getRanking(rankingId, filters): Observable<any> {
        // Instancia do body através de BaseService.setBody();
        let body = this.setBody();
        // limit: Definir o retorno máximo de últimas notícias
        //body.set('limit', '50');
        // Inicializar o id do departamento selecionado
        body.set('rankingId', rankingId);
        // Inicializar os parâmetros vindos do filtro
        if (filters !== null) {
            Object.keys(filters).forEach((filter) => {
                if (filters[filter] != null && filters[filter] != '') {
                    if (filters[filter] instanceof Array) {
                        body.set(filter, `[${filters[filter].join(',')}]`);
                    } else {
                        body.set(filter, filters[filter]);
                    }
                }
            });
        }
        //console.log(body);

        let response = this.http
            .post(this.urlService + this.routeAdress.route_ranking_rating, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}
